import { __assign, __extends, __rest } from "tslib";
// DS: B5
import React from 'react';
import classnames from 'classnames';
import Button from '../Button';
import s from './ButtonB5.scss';
var ButtonB5 = /** @class */ (function (_super) {
    __extends(ButtonB5, _super);
    function ButtonB5() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonB5.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, _b = _a.withBackground, withBackground = _b === void 0 ? true : _b, rest = __rest(_a, ["className", "children", "withBackground"]);
        return (React.createElement(Button, __assign({}, rest, { className: classnames(s['button'], withBackground && s['with-background'], className), fullWidth: false }),
            this.renderIcon(),
            children));
    };
    ButtonB5.prototype.renderIcon = function () {
        var Component = this.props.icon;
        var _a = this.props.iconProps, className = _a.className, rest = __rest(_a, ["className"]);
        return React.createElement(Component, __assign({ className: classnames(s['icon'], className) }, rest));
    };
    return ButtonB5;
}(React.Component));
export default ButtonB5;
//# sourceMappingURL=ButtonB5.js.map